import { trailerReg, truckReg } from "helpers/validators";

export function isValidCarNumber(number: string) {
    return truckReg.test(number);
}

export function isValidTrailerNumber(number: string) {
    return trailerReg.test(number);
}

export function getNumberStructure(carnumber: string) {
    if (!carnumber) {
        return null;
    }
    const result: { number: { letters: string[]; number: null | string }; region: null | string } = {
        number: { letters: [], number: null },
        region: null,
    };
    const [number, region] = carnumber.split("/");
    result.region = region;
    let currentCharType: string = "";
    const lastChars = number.split("").reduce((acc, char) => {
        if (isNumeric(char)) {
            if (currentCharType === "char") {
                result.number.letters.push(acc);
                acc = char;
            } else {
                acc += char;
            }
            currentCharType = "int";
        } else {
            if (currentCharType === "int") {
                result.number.number = acc;
                acc = char;
            } else {
                acc += char;
            }
            currentCharType = "char";
        }
        return acc;
    }, "");
    currentCharType === "char" ? result.number.letters.push(lastChars) : (result.number.number = lastChars);
    return result;
}

function isNumeric(num: any) {
    return !isNaN(num);
}
